<template>
  <div>
    <div class="pa-0 ma-0 app-list-card-expansion-header" v-if="orderDetails">
      <div
        class="d-flex algin-center justify-space-between py-1 px-0 app-relative"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              v-if="orderDetails && orderDetails.order_segment"
              :color="
                orderDetails.order_segment == 'SALES' ? 'error' : 'warning'
              "
              style="position: absolute; top: -1px; left: -13px"
              small
            >
              {{
                orderDetails.order_segment == "SALES"
                  ? "mdi-alpha-s-box"
                  : "mdi-alpha-a-box"
              }}
            </v-icon>
          </template>
          <span class="text-capitalize">
            {{ orderDetails.order_segment == "SALES" ? "sales" : "adhoc" }}
          </span>
        </v-tooltip>
        <v-checkbox
          :input-value="isChecked"
          class="ma-0 pa-0"
          hide-details
          @change="toggleOrderSelection($event, orderDetails.id)"
        >
        </v-checkbox>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="text-caption mr-1 font-weight-bold"
              v-if="orderDetails.reference_number"
              v-bind="attrs"
              v-on="on"
            >
              {{ orderDetails.reference_number }}
            </span>
          </template>
          <span class="text-capitalize">reference number</span>
        </v-tooltip>
        <CopyToClipboard
          :textTobeCopied="orderDetails.reference_number"
          iconClass="ml-2"
        />

        <v-spacer></v-spacer>

        <div
          v-if="
            orderDetails && orderDetails.warning && orderDetails.warning.message
          "
        >
          <v-tooltip right color="error" max-width="200">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon size="20" class="pr-3" color="error">
                  mdi-information
                </v-icon>
              </div>
            </template>
            <span class="text-capitalize">{{
              orderDetails.warning.message
            }}</span>
          </v-tooltip>
        </div>

        <div
          class="d-flex justify-end cf-card-space"
          v-if="
            orderDetails.rejection_reason_list &&
            orderDetails.rejection_reason_list.length != 0
          "
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon
                  size="20"
                  @click="
                    openRejectionDialog(orderDetails.rejection_reason_list)
                  "
                  class="mr-2 red--text"
                >
                  mdi-information
                </v-icon>
              </span>
            </template>
            <span class="text-capitalize">Rejection Reason</span>
          </v-tooltip>
        </div>

        <div
          class="pr-2"
          v-if="
            orderDetails && orderDetails.tags && orderDetails.tags.length > 0
          "
        >
          <v-tooltip right color="rgb(0 0 0 / 100%)">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon size="20" color="unassigned" class="pl-1">
                  mdi-alpha-t-box
                </v-icon>
              </span>
            </template>
            <span class="text-capitalize">
              <span><b>Assigned Tags</b></span
              ><br />
              <span><hr class="mt-2 mb-3" /></span>
              <span v-for="(tag, index) in orderDetails.tags" :key="index">
                {{ tag }} <br />
              </span>
            </span>
          </v-tooltip>
        </div>

        <div
          class="pr-2"
          v-if="
            orderDetails && orderDetails.zones && orderDetails.zones.length > 0
          "
        >
          <v-tooltip right color="rgb(0 0 0 / 100%)">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon size="20" color="unassigned"> mdi-alpha-z-box </v-icon>
              </span>
            </template>
            <span class="text-capitalize">
              <span><b>Assigned Zone</b></span
              ><br />
              <span><hr class="mt-2 mb-3" /></span>
              <span v-for="(zone, index) in orderDetails.zones" :key="index">
                {{ zone }} <br />
              </span>
            </span>
          </v-tooltip>
        </div>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-chip
                class="mr-1 text-capitalize font-weight-bold"
                :class="$helper.getOrderStatusColor(orderDetails.status, true)"
                x-small
                v-if="orderDetails.verbose_status"
              >
                {{ orderDetails.verbose_status }}
              </v-chip>
            </div>
          </template>
          <span class="text-capitalize"> {{ statusMapping.orderStatus }} </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <v-icon
                size="20"
                :color="
                  orderDetails.order_type == 'Pickup' ? 'warning' : 'success'
                "
              >
                mdi-{{
                  orderDetails.order_type == "Pickup"
                    ? "alpha-p-box"
                    : "alpha-d-box"
                }}</v-icon
              >
            </div>
          </template>
          <span class="text-capitalize">{{ orderDetails.order_type }}</span>
        </v-tooltip>
      </div>
    </div>
    <div class="px-0 py-2" v-if="orderDetails">
      <v-row no-gutters @click="$emit('selectedOrder', orderDetails)">
        <v-col cols="6" class="pb-1">
          <OrderTooltipWithIcon
            v-if="orderDetails.customer_name"
            icon="mdi-account"
            :text="orderDetails.customer_name"
            :label="`${customerModule.customer} name`"
          />
        </v-col>
        <v-col cols="6" class="text-right pb-1">
          <OrderTooltipWithIcon
            v-if="orderDetails.contact_number"
            icon="mdi-phone"
            :text="orderDetails.contact_number"
            label="contact name"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="$helper.isCompanyHasItems()">
          <OrderTooltipWithIcon
            v-if="orderDetails.total_items"
            icon="mdi-inbox-multiple"
            :text="orderDetails.total_items"
            label="total items"
          />
        </v-col>
        <v-col cols="6" class="text-right pb-1">
          <OrderTooltipWithIcon
            v-if="orderDetails.execution_date"
            icon=" mdi-calendar-range"
            :text="orderDetails.execution_date"
            :label="`${orderModule.order} date`"
          />
        </v-col>
        <v-col cols="12" class="d-flex">
          <OrderTooltipWithIcon
            v-if="orderDetails.volume"
            icon="mdi-package-variant-closed"
            :text="orderDetails.volume"
            :label="`${orderModule.order} volume`"
          />
          <span class="mr-6"></span>
          <OrderTooltipWithIcon
            v-if="orderDetails.weight"
            icon="mdi-weight"
            :text="orderDetails.weight"
            :label="`${orderModule.order} weight`"
          />
          <span class="mr-6"></span>
          <OrderTooltipWithIcon
            v-if="orderDetails.location_window"
            icon="mdi-timelapse"
            :text="orderDetails.location_window"
            label="delivery window"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  customerModule,
  orderModule,
  statusMapping,
} from "@/utils/moduleMapping";
import OrderTooltipWithIcon from "@/components/ModuleBasedComponents/Order/OrderTooltipWithIcon.vue";
import CopyToClipboard from "@/components/GeneralComponents/CopyToClipboard.vue";

export default {
  props: {
    orderDetails: Object,
    index: Number,
    isChecked: Boolean,
  },
  methods: {
    openRejectionDialog(reason) {
      this.$emit("openDialog", reason);
    },
    toggleOrderSelection(isChecked, orderId) {
      this.$emit("sendData", isChecked, orderId);
    },
  },
  data() {
    return {
      statusMapping,
      customerModule,
      orderModule,
    };
  },
  components: { OrderTooltipWithIcon, CopyToClipboard },
};
</script>
